module.exports = __webpack_public_path__ + "img/x-switcher.88460571.svg";